/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userBusinessFrequentBuyerPrograms.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Frequent buyer programs for this business
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class FrequentBuyerProgramsModel(
    /** Contains all user data */
    @SerialName("data")
    val data: UserProfileDataModel?,

    /** Contains frequent buyer programs */
    @SerialName("included")
    val included: FrequentBuyerProgramsIncluded?
) : Model()
